import {isEmpty, isNil} from 'lodash'
import {ITask, TaskType} from '../shared/db'
import {TempTask} from '../model'

export const splitTasks = <T extends ITask | TempTask>(
  tasks: T[],
): {eventTrackerTaskList: T[]; scheduleTaskList: T[]; legacyTaskList: T[]; hiddenTaskList: T[]} => {
  const eventTrackerTaskList: T[] = []
  const scheduleTaskList: T[] = []
  const legacyTaskList: T[] = []
  const hiddenTaskList: T[] = []

  for (const task of [...tasks].sort((a, b) => (a.index ?? 0) - (b.index ?? 0))) {
    if (task.type === TaskType.GarminDevice) {
      continue
    }
    if (task.enabled) {
      if (!isNil(task.eventTracker)) {
        eventTrackerTaskList.push(task)
      } else if (!isEmpty(task.scheduleList)) {
        scheduleTaskList.push(task)
      } else {
        legacyTaskList.push(task)
      }
    } else {
      hiddenTaskList.push(task)
    }
  }

  return {
    eventTrackerTaskList,
    scheduleTaskList,
    legacyTaskList,
    hiddenTaskList,
  }
}
